import React from "react";
import Layout from "../../HOC/Layput/Layout";
import { Accordion, Card } from "react-bootstrap";
import "./FAQ.css";
const FAQ = () => {
  document.title = "VK Global Publications |  Frequently Asked Questions"
  
  return (
    <div>
      <Accordion defaultActiveKey="0">
        <Card>
          <Accordion.Toggle as={Card.Header} className="question" eventKey="0">
            Do you ship worldwide?
            <i className="icon dripicons-arrow-thin-right float-right"></i>
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="0">
            <Card.Body className="answer">
              Yes, books are shipped to all possible destinations including
              India, US, UK, Japan, Germany, and other major Asian and Europeon
              Countries
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card>
          <Accordion.Toggle as={Card.Header} className="question" eventKey="4">
            What are the shipping cost?
            <i className="icon dripicons-arrow-thin-right float-right"></i>
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="4">
            <Card.Body className="answer">
              The shipping structure is as follows <br />
              <ol style={{ marginLeft: "25px" }}>
                <li>
                  International Book Post=> $15/- per book/copy/volume (The
                  delivery period is between 12-20 working days) (We may ask for
                  higher charges in case the books are heavy)
                </li>
                <li>
                  International courier (most countries included) => $55/- per
                  book/copy/volume. The delivery period is between 3-7 working
                  days. (We may ask for higher charges in case the books are
                  heavy)
                </li>
                <li>
                  Registered Book Post (within India) => Rs. 60/- per
                  book/copy/volume. The delivery period is between 5-10 working
                  days.
                </li>
                <li>
                  Courier within India => Rs. 80/- per book/copy/volume. The
                  delivery period is bewteen 3-7 working days. (We may ask for
                  higher charges in case the books are heavy)
                </li>
              </ol>
              Shipping charges may be modified as per prevailing market rates.
              We may also request extra shipping charges for heavy books and
              multivolume sets. However, we can reduce the shipping cost on bulk
              orders. Please contact us if you want to order in bulk at
              sales@vkpublications.com.
            </Card.Body>
          </Accordion.Collapse>
        </Card>

        <Card>
          <Accordion.Toggle as={Card.Header} className="question" eventKey="3">
            How do I make payment?
            <i className="icon dripicons-arrow-thin-right float-right"></i>
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="3">
            <Card.Body className="answer" style={{ marginLeft: "25px" }}>
              Following payment options are available
              <ol  style={{ marginLeft: "25px" }}>
                <li>
                  Credit Card (Visa/Master Cards) through Paypal Payflow
                  (previously known as Verisign Payment Gateway): You can pay
                  through your visa or master cards. We use VeriSign payment
                  gateway (128 bit encrypted) to process your credit cards.
                  Choose this payment method if your billing address is outside
                  India. The settlement currency for this method is USD.
                </li>
                <li>
                  Paypal.Com Account: Paypal.com is very popular option for
                  making online payments. There are over 96 Million registered
                  users of paypal worldwide. If you have a paypal account, you
                  can use paypal as the payment option for your purchases
                  outside India. The settlement currency is USD.
                </li>
              </ol>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card>
          <Accordion.Toggle
            as={Card.Header}
            className="question"
            eventKey="5"
          >
            Do you accept Cheques as payment option?
            <i className="icon dripicons-arrow-thin-right float-right"></i>
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="5">
            <Card.Body className="answer">
              We can accept Banker's Cheque or Demand Drafts from Indian Buyers
              if they are not able to pay through credit card or netbanking
              options.
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card>
          <Accordion.Toggle as={Card.Header} className="question" eventKey="6">
            I am from Japan,but want the books to be delivered in India. How
            should I Pay?
            <i className="icon dripicons-arrow-thin-right float-right"></i>
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="6">
            <Card.Body className="answer">
              If you are from Japan or any other country other than India,
              choose your currency to be USD or Euro. If you want the books to
              be delivered in India, use Verisign Payment Gateway or Paypal.com.
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card>
          <Accordion.Toggle as={Card.Header} className="question" eventKey="7">
          I am looking for a book, which is not listed in your database.
            <i className="icon dripicons-arrow-thin-right float-right"></i>
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="7">
            <Card.Body className="answer">
            Please let us know by e-mail the name of the book and publisher.If possible, we will try to arrange one for you.
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card>
          <Accordion.Toggle as={Card.Header} className="question" eventKey="8">
          How do you send books?
            <i className="icon dripicons-arrow-thin-right float-right"></i>
          </Accordion.Toggle>
          <Accordion.Collapse  eventKey="8">
            <Card.Body className="answer">
            Books are sent through either of the following means
            <ol  style={{ marginLeft: "25px" }}>
              <li>
              International Registered Book Post
              </li>
              <li>
              International Courier (through DHL/Fedex etc).
              </li>
              <li>
              Registered Book Post (within India Only)
              </li>
              <li>
              Through courier all over India.
              </li>
            </ol>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card>
          <Accordion.Toggle as={Card.Header} className="question" eventKey="9">
            What is the delivery period?
            <i className="icon dripicons-arrow-thin-right float-right"></i>
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="9">
            <Card.Body className="answer">
              Generally, books are shipped within 2-5 days of confirmation of
              your order. It takes about 12-30 working days to reach books in
              USA and within 12-20 working days in most European countries from
              the date of purchase.
              <br /> The delivery through courier takes about 3-7 working days.
              <br /> If your shipping address is within India, the delivery may
              take about 3-7 days through Registered Book Post and and 2-4 days
              through courier.
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card>
          <Accordion.Toggle as={Card.Header} className="question" eventKey="10">
            What is your return policy ?
            <i className="icon dripicons-arrow-thin-right float-right"></i>
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="10">
            <Card.Body className="answer">
              Our return policy is limited only if you receive books in very bad
              condition, In such cases, we will either send another copy of the
              book, if available, or issue a refund to the customer the amount
              charged minus shipping cost.
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
};

export default Layout(FAQ, " Frequently Asked Questions ");
